import { render, staticRenderFns } from "./switchbar.vue?vue&type=template&id=0ad07f1a&"
import script from "./switchbar.vue?vue&type=script&lang=js&"
export * from "./switchbar.vue?vue&type=script&lang=js&"
import style0 from "./switchbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports